import styled from 'styled-components';

type ViewerButtonProps = {
  isActive?: boolean;
};

/**
 * ViewerButton is a specially-styled type of button,
 * only used in the 3D viewer.
 */
const ViewerButton = styled.button<ViewerButtonProps>`
  background-color: ${(props) =>
    props.isActive ? '#0077f6' : 'rgba(41, 41, 41, 0.75)'};
  border-radius: 2px;
  color: #fff;

  :hover {
    background-color: ${(props) =>
      props.isActive ? '#0077f6' : 'rgba(41, 41, 41, 0.85)'};

    ${(props) =>
      props.isActive && // the following !important is just for until we merge the two viewers and can pull the partlib-specific button styles from viewerpage.js
      `
	    	margin-top:0 !important;
	    `}
  }
`;

export default ViewerButton;
